import React from 'react';
import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import ReactHtmlParser from 'html-react-parser';
import { Button as RawButton } from 'antd';
import {
  DATA_CY_EBOOK_PANE_COMPONENT,
  DATA_CY_EBOOK_PANE_COMPONENT_BTN_DOWNLOAD,
} from 'features/ebook/__tests__/constant';
import { AWS_EBOOK_BUCKET } from '../../../../constants/api';
import {
  SPaneBody,
  SPaneContainer,
  SPaneCover,
  SPaneHeader,
  SPaneHeaderWrapper,
  SPaneTitle,
} from '../styled';

export const SDownloadButton = styled(RawButton)`
  color: unset;
  border-color: ${color.gainsboro};

  :hover,
  :focus {
    color: unset;
    border-color: ${color.gainsboro};
  }

  ::after {
    content: unset;
  }

  width: 100px;
  height: 30px;
  padding: 0px;
  position: relative;
  display: block;

  &&& ${Text} {
    color: ${color.primary};
    line-height: 30px;
    text-align: center;
    border-radius: 2px;
    background: ${color.light};
  }

  float: right;
  position: relative;
  bottom: 20px;
`;

const Pane = ({
  bookTitle,
  bookDescription,
  bookCover,
  downloadCounts,
  downloadName,
}: {
  bookTitle: string;
  bookDescription: string;
  bookCover: string;
  downloadCounts: number;
  downloadName: string;
}) => (
  <SPaneContainer data-cy={DATA_CY_EBOOK_PANE_COMPONENT}>
    <SPaneHeader>
      <SPaneHeaderWrapper>
        <SPaneTitle>{bookTitle}</SPaneTitle>
        <SDownloadButton>
          <Text
            as="a"
            onClick={() =>
              window.open(`${AWS_EBOOK_BUCKET}/${downloadName}`, '_blank')
            }
            data-cy={DATA_CY_EBOOK_PANE_COMPONENT_BTN_DOWNLOAD}
          >
            Download
          </Text>
        </SDownloadButton>
        <Text size="12px" color={color.midgray}>
          {downloadCounts} Downloads
        </Text>
      </SPaneHeaderWrapper>
    </SPaneHeader>
    <SPaneBody>
      <SPaneCover src={`${AWS_EBOOK_BUCKET}/${bookCover}`} />
      {ReactHtmlParser(bookDescription)}
    </SPaneBody>
  </SPaneContainer>
);

export default Pane;
